<template>
  <div class="page-base">
    <div class="g-wrap">
      <column-header2 :data="baseMeta"></column-header2>
      <div class="column-wrap intro-wrap">
        <div class="left">
          <div class="content" v-html="baseData.Introduction"></div>
          <router-link class="link" :to="`${$subsitePrefix}/company/info/${id}`">查看详细+</router-link>
        </div>
        <div class="right">
          <img @error="imgError" :src="baseData.MainPicture" :alt="baseMeta.Name" />
        </div>
      </div>
    </div>
    <div class="product-wrap">
      <div class="g-wrap">
        <column-header2 :data="productMeta"></column-header2>
        <div class="column-wrap">
          <product-card v-for="item in productList" :data="item" :key="item.id"></product-card>
        </div>
      </div>
    </div>
    <div class="g-wrap contact-wrap">
      <column-header2 :data="{ name: '联系方式' }"></column-header2>
      <div class="column-wrap">
        <div class="cell">
          <i class="ico-tel"></i>
          <p>{{ baseData.Phone }}</p>
        </div>
        <div class="cell">
          <i class="ico-email"></i>
          <p>{{ baseData.Email }}</p>
        </div>
        <div class="cell">
          <i class="ico-addr"></i>
          <p>{{ baseData.Address }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColumnHeader from "_c/ColumnHeader2";
import ProductCard from "./ProductCard";
import { getData, getDetail } from "api/app";
export default {
  name: "panel-base",
  data() {
    return {
      id: this.$route.params.id,
      baseMeta: {
        name: "企业简介"
      },
      productMeta: {
        name: "产品服务",
        link: `${this.$subsitePrefix}/company/product/${this.$route.params.id}`
      },
      baseData: {},
      productList: []
    };
  },
  created() {
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader,
    [ProductCard.name]: ProductCard
  },
  methods: {
    loadData() {
      getDetail({ name: "Enterprise", id: this.id }).then(res => {
        this.baseData = res || {};
      });
      var productParam = {
        name: "ProductService",
        top: 3,
        params: [{ Key: "Enterprise", Value: this.id, CompareType: "EqualTo" }]
      };
      getData(productParam).then(res => {
        this.productList = res || [];
      });
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-base {
  .column-wrap {
    display: flex;
    justify-content: space-between;
  }
  .intro-wrap {
    height: 266px;
    padding-bottom: 40px;
    .left {
      width: 768px;
      color: rgba(102, 102, 102, 1);
      line-height: 28px;
      .content {
        height: 250px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 9;
        overflow: hidden;
        text-overflow: ellipsis;
        ::v-deep p {
          text-indent: 2em;
        }
      }
      .link {
        color: $primary-color;
        &:hover {
          color: $link-active-color;
        }
      }
    }
    .right {
      width: 376px;
      height: 266px;
      overflow: hidden;
      border-radius: 8px;
    }
  }
  .product-wrap {
    background-color: #f6f6f9;
    padding-bottom: 16px;
  }
  .contact-wrap {
    .column-wrap {
      justify-content: space-around;
      align-content: center;
      padding: 16px 0 48px 0;
    }
    .cell {
      flex: 1;
      text-align: center;
      font-size: 18px;
      line-height: 24px;
      i {
        display: inline-block;
        width: 48px;
        height: 48px;
        background: url(~assets/img/feature/ico-tel.png) no-repeat;
      }
      .ico-email {
        background-image: url(~assets/img/feature/ico-email.png);
      }
      .ico-addr {
        background-image: url(~assets/img/feature/ico-addr.png);
      }
      p {
        margin-top: 6px;
      }
    }
  }
}
</style>
